import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../components/Home.vue'
import TheContainer from '../components/TheContainer.vue'
// login
import Login from '../views/login/Login.vue'
import PostLogin from '../views/login/PostLogin.vue'

// main components
import ProfileTab from '../views/main_components/ProfileTab.vue'
import MessageTab from '../views/main_components/MessageTab.vue'
import HomeTab from '../views/main_components/HomeTab.vue'
// create request
import CustomerInfo from '../views/add_request/CustomerInfo.vue'
import Categories from '../views/add_request/Categories.vue'
import Groups from '../views/add_request/Groups.vue'
import SubGroups from '../views/add_request/SubGroups.vue'
import Brands from '../views/add_request/Brands.vue'
import RequestPreDefined from '../views/add_request/RequestPreDefined.vue'
import RequestDetail from '../views/add_request/RequestDetail.vue'
import SignatureRequest from '../views/add_request/RequestSignature.vue'
import RequestAttachments from "../views/add_request/RequestAttachments";
import RequestAddress from "../views/add_request/RequestAddress";
// messenger

// report request
import ReferredRequest from '../views/report_request/ReferredRequests.vue'
import ReportReferredRequest from '../views/report_request/ReportReferredRequests.vue'
import ViewRequest from '../views/report_request/ViewRequestDetail.vue'
import ViewPreRequest from '../views/report_request/ViewPreRequestDetail.vue'
import SafirDevices from "../views/report_request/SafirDevices";

// messenger
import ChatDetail from '../views/messenger/ChatDetail.vue'
import Contacts from '../views/messenger/Contacts.vue'
import AddGroup from '../views/messenger/AddGroup.vue'
import SavedMessage from '../views/messenger/SavedMessage.vue'
import ContactInfo from '../views/messenger/ContactInfo.vue'

// profile
import Setting from '../views/profile/Setting.vue'
import EditProfile from '../views/profile/EditProfile.vue'
import SendSms from '../views/profile/SendSms.vue'
import ChangePassword from '../views/profile/ChangePassword.vue'
import ContactUs from "../views/profile/ContactUs";
import ReportTab from "../views/main_components/ReportTab";
import AddQuestion from "../views/questions/AddQuestion";
import MyRequests from "../views/report_request/MyRequests";
import MyQuestions from "../views/questions/MyQuestions";
import QuestionInfo from "../views/questions/QuestionInfo";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // redirect: "/dashboard",
    name: 'صفحه اصلی',
    component: TheContainer,
    children: [
      {
        path: '/',
        redirect:'/home-tab',
        name: 'داشبورد',
        meta: {
          requiresAuth: true,
          requiresPost: false,

          name: 'داشبورد'
        },
      },
      {
        path: '/login',
        name: 'login',
        component: Login
      },
      {
        path: '/contact-us',
        name: 'ContactUs',
        component: ContactUs,
        meta: {
        name: 'تماس با ما'
        },
      },
      {
        path: '/post-login',
        name: 'post_login',
        meta: {
          requiresAuth: true,
          requiresPost: false,
          name: 'ورود به پست سازمانی'
        },

        component: PostLogin
      },
      {
        path: '/home-tab',
        name: 'home',
        meta: {
          requiresAuth: true,
          requiresPost: false,
          name: 'خانه'
        },

        component: HomeTab
      },
      {
        path: '/message-tab',
        name: 'messenger',
        meta: {
          requiresAuth: true,
          name: 'پیام رسان'
        },

        component: MessageTab
      },
      {
        path: '/profile-tab',
        name: 'profile',
        meta: {
          requiresAuth: true,
          name: 'پروفایل'
        },
        component: ProfileTab
      },
      {
        path: '/report-tab',
        name: 'report',
        meta: {
          requiresAuth: true,
          name: 'گزارشات'
        },
        component: ReportTab
      },

      {
        path: '/chat-detail',
        name: 'مکالمه',
        meta: {
          requiresAuth: true,
          name: 'مکالمه'
        },

        component: ChatDetail
      },
      {
        path: '/setting',
        name: 'تنظیمات',
        meta: {
          requiresAuth: true,
          name: 'تنظیمات'
        },
        component: Setting
      },
      {
        path: '/saved-message',
        name: 'پیام های ذخیره شده',
        meta: {
          requiresAuth: true,
          name: 'پیام های ذخیره شده'
        },
        component: SavedMessage
      },
      {
        path: '/contacts',
        name: 'مخاطب ها',
        meta: {
          requiresAuth: true,
          name: 'مخاطب ها'
        },
        component: Contacts
      },
      {
        path: '/contact-info',
        name: 'اطلاعات مخاطب',
        meta: {
          requiresAuth: true,
          name: 'اطلاعات مخاطب'
        },
        component: ContactInfo
      },
      {
        path: '/add-group',
        name: 'افزودن گروه',
        meta: {
          requiresAuth: true,
          name: 'افزودن گروه'
        },
        component: AddGroup
      },
      {
        path: '/edit-profile',
        name: 'ویرایش پروفایل',
        meta: {
          requiresAuth: true,
          name: 'ویرایش پروفایل'
        },
        component: EditProfile
      },
      {
        path: '/change-password',
        name: 'تغییر رمز عبور',
        meta: {
          requiresAuth: true,
          name: 'تغییر رمز عبور'
        },
        component: ChangePassword
      },
      {
        path: '/send-sms',
        name: 'ارسال کد',
        meta: {
          requiresAuth: true,
          name: 'ارسال کد'
        },
        component: SendSms
      },
      {
        path: '/about',
        name: 'درباره ما',
        meta: {
          requiresAuth: true,
          name: 'درباره ما'
        },

        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      },
      //****************************************************
      //****************************************************

      {
        path: '/create-request',
        name: 'ثبت درخواست',
        meta: {
          requiresAuth: true,
          requiresPost: false,
          name: 'ثبت درخواست'
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'customer-info',
            name: 'CustomerInfo',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'اطلاعات مشتری'
            },
            component: CustomerInfo
          }, {
            path: 'categories',
            name: 'Categories',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'دسته بندی'
            },
            component: Categories
          }, {
            path: 'groups',
            name: 'groups',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'گروه'
            },
            component: Groups
          }, {
            path: 'subgroups',
            name: 'SubGroups',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'زیر گروه'
            },
            component: SubGroups
          }, {
            path: 'brands',
            name: 'brands',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'برند'
            },
            component: Brands
          }, {
            path: 'predefined',
            name: 'predefined',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'اطلاعات پایه'
            },
            component: RequestPreDefined
          }, {
            path: 'details',
            name: 'request_detail',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'اطلاعات درخواست'
            },
            component: RequestDetail
          }, {
            path: 'signature/:rec_id/:type_id',
            name: 'signature',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'امضا مشتری'
            },
            component: SignatureRequest
          }, {
            path: 'attachment/:rec_id',
            name: 'attachment',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'فایل های ضمیمه'
            },
            component: RequestAttachments
          }, {
            path: 'address/:rec_id',
            name: 'requestAddress',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'آدرس درخواست'
            },
            component: RequestAddress
          },
        ]
      },
   //****************************************************
   //****************************************************
      {
        path: '/report-request',
        name: 'اطلاعات درخواست',
        meta: {
          requiresAuth: true,
          requiresPost: false,
          name: 'اطلاعات درخواست'
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'referred-request',
            name: 'ReferredRequest',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'ارجاعیات'
            },
            component: ReferredRequest
          }, {
            path: 'my-requests',
            name: 'MyRequests',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'درخواست های من'
            },
            component: MyRequests
          },{
            path: 'report-referred-request',
            name: 'ReportReferredRequest',
            props: true,
            meta: {
              requiresAuth: true,
              name: 'گزارش ارجاعیات',
              requiresPost: false,

            },
            component: ReportReferredRequest
          },{
            path: 'view-request/:rec_id',
            name: 'ViewRequest',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'نمایش درخواست'
            },
            component: ViewRequest
          },{
            path: 'view-pre-request/:rec_id',
            name: 'ViewPreRequest',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'نمایش پیش درخواست'
            },
            component: ViewPreRequest
          },{
            path: 'safir-devices',
            name: 'SafirDevices',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'دستگاه های سفیر'
            },
            component: SafirDevices
          },
        ]
      },

      //*****************************************
      {
        path: '/questions',
        name: 'ثبت سوال',
        meta: {
          requiresAuth: true,
          requiresPost: false,
          name: 'ثبت سوال'
        },
        component: {
          render (c) {
            return c('router-view')
          }
        },

        children: [
          {
            path: 'add-question',
            name: 'AddQuestion',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'ثبت سوال'
            },
            component: AddQuestion
          }, {
            path: 'my-questions',
            name: 'MyQuestions',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'سوالات شما'
            },
            component: MyQuestions
          },{
            path: 'question-info/:rec_id',
            name: 'QuestionInfo',
            props: true,
            meta: {
              requiresAuth: true,
              requiresPost: false,
              name: 'سوالات شما'
            },
            component: QuestionInfo
          },
        ]
      },
      //****************************************************
    ],

  },
]

const router = new VueRouter({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({y: 0}),
  routes
})

function validate_user(next, to) {
  let self = this;
  const formData = new FormData()
  let url;
  url = "/api/admin/validate-token";

  formData.append('token', localStorage.getItem('token'))

  axios.post(url, formData, {}).then((res) => {
    console.log("validate token is " + res.data);


    if (res.data.validate) {
      console.log("validate is true");
      let meta_role = to.meta.requiresRole;
      // console.log("user name is "+ this.user_permissions.includes("edit_settings"));
      if (meta_role == null) {
        console.log("requiresRole is null");
        next();

      } else {
        console.log("requiresRole is " + meta_role);
        let permissions = res.data.permissions;
        if (permissions.includes(meta_role)) {
          console.log("user has permissions ");
          next();

        } else {
          next({
            path: '/dashboard/404',
            params: {nextUrl: to.fullPath}
          });
        }

      }

    } else {
      console.log("validate is false");

      next({
        path: '/dashboard/login',
      })
    }
    // return res.data;
  })

    // axios.post(  '/admin/category', {
    //     name: self.name,
    //     description: self.description,
    //     image: self.image,
    //     cat: 0,
    // }).then(function (response) {
    //     self.name = '';
    //     self.description = '';
    //     // localStorage.setItem("api_token", response.data.access_token);
    //     // self.$router.push({ path: 'notes' });
    // })
    .catch(function (error) {
      self.message = 'Incorrect E-mail or password';
      self.showMessage = true;
      console.log(error);
    });

}

export default router

router.beforeEach((to, from, next) => {
  // console.log("before each" + " token is " + localStorage.getItem('token'));
  // console.log("before each"+next);
  // if (to.path == '/') {
  //   //  window.location.href = '/home';
  // }


  if (to.matched.some(record => record.meta.requiresAuth)) {

    if (localStorage.getItem('phone') == null || localStorage.getItem('phone') == '') {

      next({
        path: '/login',
        params: {nextUrl: to.fullPath}
      })
    } else {
      // validate_user(next, to);
next();

      // let user = JSON.parse(localStorage.getItem('user'))
      // if(to.matched.some(record => record.meta.is_admin)) {
      //     if(user.is_admin == 1){
      //         next()
      //     }
      //     else{
      //         next({ name: 'userboard'})
      //     }
      // }else {
      //     next()
      // }
    }
  }
  if (to.matched.some(record => record.meta.requiresPost)) {
   if(localStorage.getItem("party_id")== null || localStorage.getItem("party_id") == ''){
      next({
        path: '/post-login',
        params: {nextUrl: to.fullPath}
      })

    } else {
      // validate_user(next, to);
next();

      // let user = JSON.parse(localStorage.getItem('user'))
      // if(to.matched.some(record => record.meta.is_admin)) {
      //     if(user.is_admin == 1){
      //         next()
      //     }
      //     else{
      //         next({ name: 'userboard'})
      //     }
      // }else {
      //     next()
      // }
    }
  }

  else {
    next()
  }
});
